export default "__VITE_ASSET__DPQt7cnm__"